import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function CookiesPolicy() {
  const { lang } = useLang();

  return (
    <div style={{ background: '#0A0B0F', minHeight: '100vh' }} className="py-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link 
          to={`/${lang}`}
          className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#BFC3C9] transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          <span>{lang === 'ru' ? 'Назад на главную' : 'Volver a inicio'}</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-white mb-8 font-heading">
          {lang === 'ru' ? 'Политика Cookie' : 'Política de Cookies'}
        </h1>

        <div className="prose prose-invert max-w-none">
          {lang === 'ru' ? (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. Что такое cookies?</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Cookie — это небольшой текстовый файл, который веб-сайт сохраняет на вашем компьютере или мобильном устройстве при посещении сайта. Cookies позволяют веб-сайту запоминать ваши действия и предпочтения на определенный период времени.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. Как мы используем cookies?</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Данный веб-сайт использует cookies для:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Запоминания настроек языка</li>
                  <li>Анализа посещаемости и использования сайта</li>
                  <li>Улучшения функциональности сайта</li>
                  <li>Запоминания вашего согласия на использование cookies</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Типы используемых cookies</h2>
                
                <h3 className="text-xl font-bold text-white mb-3 mt-6">Необходимые cookies</h3>
                <p className="text-[#BFC3C9] mb-4">
                  Эти cookies необходимы для корректной работы веб-сайта и не могут быть отключены. Они обычно устанавливаются в ответ на ваши действия, такие как выбор языка или согласие на cookies.
                </p>

                <h3 className="text-xl font-bold text-white mb-3 mt-6">Аналитические cookies</h3>
                <p className="text-[#BFC3C9] mb-4">
                  Эти cookies помогают нам понять, как посетители взаимодействуют с сайтом, предоставляя информацию о количестве посетителей, времени пребывания на сайте и посещенных страницах.
                </p>

                <h3 className="text-xl font-bold text-white mb-3 mt-6">Функциональные cookies</h3>
                <p className="text-[#BFC3C9] mb-4">
                  Эти cookies позволяют сайту запоминать сделанный вами выбор (например, язык) и предоставлять расширенные персонализированные функции.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Сторонние cookies</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Некоторые cookies могут устанавливаться третьими лицами при использовании их сервисов на нашем сайте (например, Google Analytics). Мы не контролируем установку этих cookies.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Управление cookies</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Вы можете контролировать и/или удалять cookies по своему усмотрению. Вы можете удалить все cookies, которые уже есть на вашем компьютере, и настроить большинство браузеров на блокировку их установки.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  Однако имейте в виду, что если вы это сделаете, вам, возможно, придется вручную настраивать некоторые предпочтения каждый раз при посещении сайта, и некоторые функции могут не работать.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">6. Как отказаться от cookies</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Большинство браузеров позволяют управлять настройками cookies:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li><strong>Google Chrome:</strong> Настройки → Конфиденциальность и безопасность → Файлы cookie</li>
                  <li><strong>Mozilla Firefox:</strong> Настройки → Приватность и защита → Куки и данные сайтов</li>
                  <li><strong>Safari:</strong> Настройки → Конфиденциальность → Файлы cookie</li>
                  <li><strong>Microsoft Edge:</strong> Настройки → Конфиденциальность и службы → Файлы cookie</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">7. Изменения в политике cookies</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Мы можем время от времени обновлять эту Политику cookies. Любые изменения будут опубликованы на этой странице.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">8. Контакты</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Если у вас есть вопросы о нашей Политике cookies, свяжитесь с нами:<br />
                  <strong>Email:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a>
                </p>
              </section>
            </>
          ) : (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. ¿Qué son las cookies?</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Una cookie es un pequeño archivo de texto que un sitio web guarda en su ordenador o dispositivo móvil cuando lo visita. Las cookies permiten que el sitio web recuerde sus acciones y preferencias durante un período de tiempo.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. ¿Cómo usamos las cookies?</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Este sitio web utiliza cookies para:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Recordar las preferencias de idioma</li>
                  <li>Analizar el tráfico y el uso del sitio</li>
                  <li>Mejorar la funcionalidad del sitio</li>
                  <li>Recordar su consentimiento sobre el uso de cookies</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Tipos de cookies que utilizamos</h2>
                
                <h3 className="text-xl font-bold text-white mb-3 mt-6">Cookies necesarias</h3>
                <p className="text-[#BFC3C9] mb-4">
                  Estas cookies son esenciales para el correcto funcionamiento del sitio web y no se pueden desactivar. Normalmente se establecen en respuesta a sus acciones, como la elección de idioma o el consentimiento de cookies.
                </p>

                <h3 className="text-xl font-bold text-white mb-3 mt-6">Cookies analíticas</h3>
                <p className="text-[#BFC3C9] mb-4">
                  Estas cookies nos ayudan a entender cómo los visitantes interactúan con el sitio, proporcionando información sobre el número de visitantes, el tiempo de permanencia y las páginas visitadas.
                </p>

                <h3 className="text-xl font-bold text-white mb-3 mt-6">Cookies funcionales</h3>
                <p className="text-[#BFC3C9] mb-4">
                  Estas cookies permiten que el sitio recuerde las opciones que usted hace (como el idioma) y proporcionar funciones mejoradas y personalizadas.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Cookies de terceros</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Algunas cookies pueden ser establecidas por terceros al usar sus servicios en nuestro sitio (por ejemplo, Google Analytics). No controlamos la instalación de estas cookies.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Gestión de cookies</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Puede controlar y/o eliminar cookies a su discreción. Puede eliminar todas las cookies que ya están en su ordenador y configurar la mayoría de los navegadores para bloquear su instalación.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  Sin embargo, tenga en cuenta que si hace esto, es posible que tenga que ajustar manualmente algunas preferencias cada vez que visite el sitio, y algunas funciones pueden no funcionar.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">6. Cómo rechazar las cookies</h2>
                <p className="text-[#BFC3C9] mb-4">
                  La mayoría de los navegadores permiten gestionar la configuración de cookies:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li><strong>Google Chrome:</strong> Configuración → Privacidad y seguridad → Cookies</li>
                  <li><strong>Mozilla Firefox:</strong> Configuración → Privacidad y seguridad → Cookies y datos del sitio</li>
                  <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies</li>
                  <li><strong>Microsoft Edge:</strong> Configuración → Privacidad y servicios → Cookies</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">7. Cambios en la política de cookies</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Podemos actualizar periódicamente esta Política de cookies. Cualquier cambio se publicará en esta página.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">8. Contacto</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Si tiene preguntas sobre nuestra Política de cookies, contáctenos:<br />
                  <strong>Email:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a>
                </p>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
